export default {
  SET_ARCHETYPE: '@YOLA_TEMPLATE_GALLERY/SITE_SETUP/SET_ARCHETYPE',
};
